import React, { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import axios from "../../api/axios";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import {
  getCountryCommunities,
  unsetCommunity,
} from "../../features/communitiesSlice";
import { zodResolver } from "@hookform/resolvers/zod";
import { addUserSchema } from "../../schemas";
import { findRoleById, loadStatus } from "../../util";
import { addUser } from "../../features/usersSlice";
import { closeModal } from "../../features/modalSLice";
import Loading from "../../components/loading/Loading";
import { useNotification } from "../../components/notification/NotificationContainer";
import NetworkError from "../error/NetworkError";

const AddUser = ({ id }) => {
  const dispatch = useDispatch();
  const communities = useSelector((state) => state.communities.data);
  const addUserLoad = useSelector((state) => state.users.load.addUser);
  const user = useSelector((state) => state.user.userInfo);
  const [roles, setRoles] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const addNotification = useNotification();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      other_names: "",
      role_id: "",
      organization_id: "",
      community_id: "",
    },
    resolver: zodResolver(addUserSchema),
  });
  const watchAllFields = watch();

  //Get register organization, and roles
  const getRegister = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get("/register", {
        params: { id },
      });
      setRoles(
        response.data.roles.filter(
          (item) => item.name.toLowerCase() !== "super administrator"
        )
      );
      setOrganizations(response.data.organizations);
      setDepartments(response.data.departments);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      if (!error.response) {
      }
      dispatch(closeModal());
    }
  }, [setRoles]);

  //When the form is submitted add the user
  const onSubmit = async (data, e) => {
    e.preventDefault();
    let res;
    try {
      if (
        (findRoleById(roles, data.role_id, "community cordinator") &&
          data.community_id) ||
        !findRoleById(roles, data.role_id, "community cordinator")
      ) {
        //Submit data
        res = await dispatch(addUser(data));
        if (addUser.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("User added successfully", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        addNotification("There is no Community Id", "error");
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  //Get Role Values
  useEffect(() => {
    getRegister();
    setValue("organization_id", "");
    setValue("role_id", "");
  }, []);

  useEffect(() => {
    let role;
    if (watchAllFields.role_id) {
      role = roles.find((item) => item.id === watchAllFields.role_id);
    }
    if (watchAllFields.organization_id) {
      setValue("community_id", "");
      dispatch(getCountryCommunities(watchAllFields.organization_id));
    } else {
      setValue("community_id", "");
      dispatch(unsetCommunity());
    }
  }, [watchAllFields.organization_id]);

  if (loading === loadStatus.loading) {
    return <Loading />;
  }

  return (
    <div className="overflow-auto">
      <h3 className="text-center m-7">Add User</h3>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <InputField
            register={register}
            errors={errors.first_name}
            label="First Name"
            name="first_name"
            type="text"
          />
          <InputField
            register={register}
            errors={errors.last_name}
            label="Last Name"
            name="last_name"
            type="text"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <InputField
            register={register}
            errors={errors.other_names}
            label="Other Names"
            name="other_names"
            placeholder="Kojo"
            type="text"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <SelectField
            register={register}
            errors={errors.organization_id}
            data={[{ id: "", name: "-- Select Location" }, ...organizations]}
            name="organization_id"
            label="Country or Station"
          />
          <SelectField
            register={register}
            errors={errors.role_id}
            data={[{ id: "", name: "-- Select Role" }, ...roles]}
            name="role_id"
            label="Role"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <SelectField
            register={register}
            data={[{ id: "", name: "--Select Department" }, ...departments]}
            errors={errors.department}
            name="department_id"
            label="Department"
          />
          <SelectField
            register={register}
            errors={errors.community_id}
            data={[{ id: "", name: "--Select Community" }, ...communities]}
            name="community_id"
            label="Community"
          />
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          <InputField
            register={register}
            errors={errors.email}
            label="Email"
            name="email"
            placeholder="david@examplie.com"
            type="email"
            autoComplete="false"
          />

          <div className="flex-1"></div>
        </div>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row">
          {" "}
          <InputField
            register={register}
            errors={errors.password}
            label="Password"
            name="password"
            type="password"
          />
          <InputField
            register={register}
            errors={errors.confirm_password}
            label="Confirm Password"
            name="confirm_password"
            type="password"
          />
        </div>
        <InputField
          type="hidden"
          register={register}
          name="province_id"
          defaultValue={user.province_id || ""}
        />
        <ResourseButtons loading={addUserLoad} />
      </form>
    </div>
  );
};

export default AddUser;
